import jwt from '@src/auth/jwt/useJwt'

export const fetchPostMsgApi = async ({ filters, offset, userId }) => {
  const params = {}

  if (filters.user_id) params.user_id = filters.user_id
  if (filters.meli_user_id) params.meli_user_id = filters.meli_user_id
  if (filters.order_id) params.order_id = filters.order_id
  if (filters.from) params.from = filters.from
  if (filters.to) params.to = filters.to
  if (filters.order) params.order = filters.order
  params.offset = String(offset)

  try {
    const response = await jwt.get('admin/clients/message-post', {
      params,
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status

    if (status === 403) {
      const err = new Error('Forbidden')
      err.type = 'FORBIDDEN'
      throw err
    }

    if (status === 400) {
      const message = error?.response?.data?.error || 'Parámetros inválidos'
      const err = new Error(message)
      err.type = 'BAD_REQUEST'
      throw err
    }

    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
